import NoPosts from '../../components/no-posts';
import NoPostsWriter from '../../components/no-posts-writer';
import forPostWriter from '../../hoc/for-post-writer';

export default forPostWriter(NoPostsWriter, NoPosts);
